module.exports = __webpack_public_path__ + "static/TestimonialsHero-940221db26534c5b07a129a0a75911d7.jpg";